import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './../auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  changeForm!: FormGroup;
  current_password = '';
  new_password = '';
  isActive = false;
  confirmPassword = '';
  disableButton = false;
  invalidCurrentPasswordMsg = '';
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.changeForm = this.formBuilder.group({
      current_password: ['', [Validators.required, Validators.minLength(8)]],
      new_password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/
          ),
        ],
      ],
      confirm_new_password: ['', [Validators.required]],
    });
  }

  cancel() {
    const sysPassChanged = JSON.parse(
      localStorage.getItem('systemPasswordChanged') || ''
    );
    if (sysPassChanged) {
      this.router.navigate(['/dashboard/home']);
    } else {
      localStorage.clear();
      this.router.navigate(['/login']);
    }
  }

  changePassword() {
    this.disableButton = true;
    let data = {
      oldPassword: this.current_password,
      newPassword: this.new_password,
    };
    this.authService.change_password(data).subscribe(
      (data: any) => {
        this.disableButton = false;
        this.snackBar.open('Password updated successfully', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
        localStorage.clear();
        this.router.navigate(['/login']);
      },
      (error) => {
        this.disableButton = false;
        if (!navigator.onLine) {
          error.error.message =
            'OOPS! NO INTERNET. Please check your network connection.';
        }
        this.snackBar.open(
          error?.error?.message || 'Something went wrong',
          '',
          {
            duration: 2000,
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
          }
        );
      }
    );
  }
}
